import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { FeesInfo } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { computed, ref } from 'vue';
import { useTradeState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeeSettleModal',
  props: {
    feesInfo: null
  },
  emits: ["fees-settled"],
  setup(__props: any, { emit }: { emit: ({
  /**
   * Emits:
   * - fees-settled (no payload): trigger when fees were settled successfully
   */
  (e: 'fees-settled', value: void): void;
}), expose: any, slots: any, attrs: any }) {



const settleFeesModal = ref<InstanceType<typeof BModal> | null>(null);

const tradeState = useTradeState();

const requestManager = useRequestManager();

const onBehalfOfClient = useOnBehalfOf();



const clientId = computed(
  () => onBehalfOfClient.value?.id || tradeState.store.useAuthStore().loggedInIdentity!.client!.id
);

function settleFees() {
  requestManager.manager
    .cancelAndNew('settleFees', tradeState.services.wallet.settleFees(clientId.value, onBehalfOfClient.value?.id))
    .subscribe(() => {
      emit('fees-settled');
      // TODO composition API
      // this.$toast.success('Fees settled successfully');
      settleFeesModal.value?.hide();
    });
}

function show() {
  settleFeesModal.value?.show();
}

function hide() {
  requestManager.manager.cancel('settleFees');
  settleFeesModal.value?.hide();
}

return { __sfc: true,settleFeesModal, tradeState, requestManager, onBehalfOfClient, emit, clientId, settleFees, show, hide, BModal, formatCurrencyValue }
}

})